<template>
  <div class="app-container">
    <el-table :data="list"  border>
	  <el-table-column label="公会ID" align="center" prop="guildNumber" min-width="100"/>
	  <el-table-column label="会长信息" align="center" prop=""  min-width="200">
	    <template slot-scope="scope">
	      <div>会长ID:{{scope.row.guildLeaderUserRecodeCode}}</div>
	      <div>会长昵称:{{scope.row.guildLeaderUserNickName}}</div>
	  		  <div>会长手机号:{{scope.row.guildLeaderUserPhone}}</div>
	    </template>
	  </el-table-column>
	  <el-table-column prop="avatar" label="公会头像" align="center" min-width="100">
	    <template slot-scope="scope">
	      <el-popover placement="top-start" title="" trigger="click" content="" v-if="scope.row.avatar">
	        <img :src="scope.row.avatar" style="width: 500px">
	        <img slot="reference" :src="scope.row.avatar" style="width: 50px;height: 50px;border-radius: 5px;object-fit: cover;">
	      </el-popover>
	    </template>
	  </el-table-column>
	  <el-table-column label="公会名称" align="center" prop="guildName" min-width="100"/>
	  <el-table-column label="公会简介" align="center" prop="intro" width="150">
	    <template slot-scope="scope">
	      <div v-if="scope.row.intro && scope.row.intro.length > 10">
	        <el-popover placement="top-start" trigger="hover" :content="scope.row.intro" width="300">
	            <div class="intro" slot="reference">{{scope.row.intro}}</div>
	          </el-popover>
	      </div>
	      <div v-else class="intro">{{scope.row.intro}}</div>
	    </template>
	  </el-table-column>
	  <el-table-column label="公会总人数" align="center" prop="memberNumber" min-width="100"/>
	  <el-table-column label="审核状态" align="center" prop="bankCard" min-width="100">
	    <template slot-scope="scope">
	      <div>{{scope.row.status === 0?'审核中' :scope.row.status === 1?'审核通过' :'审核拒绝'}}</div>
	      <div v-if="scope.row.status ==2 && scope.row.auditRemarks">备注：{{scope.row.auditRemarks}}</div>
	    </template>
	  </el-table-column>
	  <el-table-column label="提交时间" align="center" prop="createTime" width="180">
	    <template slot-scope="scope">
	      <span>{{timestampFormat(scope.row.createTime)}}</span>
	    </template>
	  </el-table-column>
	  <el-table-column label="操作" align="center" width="100" v-if="user && user.isGuildLeader == 1">
	    <template slot-scope="scope">
	      <el-button size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)">修改公会</el-button>
	    </template>
	  </el-table-column>
    </el-table>
	<!-- 添加或修改参数配置对话框 -->
	<el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
	  <el-form ref="form" :model="form" :rules="rules" label-width="100px">
	    <el-form-item label="公会昵称" prop="guildName" >
	      <el-input v-model="form.guildName" placeholder="公会昵称" />
	    </el-form-item>
		<el-form-item label="公会简介" prop="intro" >
		  <el-input v-model="form.intro" placeholder="公会简介" type="textarea" :rows="2" />
		</el-form-item>
		<el-form-item label="公会头像" prop="avatar">
		  <el-upload class="avatar-uploader photo" list-type="picture-card" :http-request="(res)=>{return Upload(res, 'avatar')}" :multiple="false" :show-file-list="false" action="" :before-upload="beforeAvatarUpload" accept="image/jpeg,image/png">
		    <img v-if="form.avatar" :src="form.avatar" width="145" height="145">
		    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
		  </el-upload>
		</el-form-item>
	  </el-form>
	  <div slot="footer" class="dialog-footer">
	    <el-button type="primary" @click="submitForm">确 定</el-button>
	    <el-button @click="cancel">取 消</el-button>
	  </div>
	</el-dialog>
  </div>
</template>

<script>
import { getMyGuildInfo,updateGuildInfo } from "@/api/gonghui";
import Cookies from 'js-cookie'
import { client } from '../../common/js/alioss'
export default {
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 参数表格数据
      list: [],
      // 弹出层标题
      title: "公会详情",
      // 是否显示弹出层
      open: false,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        
      },
      // 表单参数
      form: {
        avatar:'',
        guildName:'',
        intro:'',
        userRecode:'',
      },
	  user:'',
      // 表单校验
      rules: {
    
      }
    };
  },
  created() {
	const data = JSON.parse(Cookies.get('user'))
	this.user = data
	this.queryParams.guildId = data.guildId
    this.getList();
  },
  methods: {
	beforeAvatarUpload(file){},
	Upload(file, index) {
	  var fileName = 'webStorage/web_' + file.file.uid+Math.floor(Math.random()*10000) + file.file.name.substr(file.file.name.indexOf("."));
	  client().put(fileName, file.file).then(result => {
	    this.form.avatar = result.url;
	    console.log(this.form.avatar);
	  }).catch(function (err) {
	    console.log(err);
	  });
	},
	zeroize(num) {
		return (String(num).length == 1 ? "0" : "") + num;
	},
	timestampFormat(timestamp) {
		var curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
		var timestampDiff = curTimestamp - parseInt(timestamp / 1000); // 参数时间戳与当前时间戳相差秒数
		var curDate = new Date(curTimestamp * 1000); // 当前时间日期对象
		var tmDate = new Date(parseInt(timestamp / 1000) * 1000); // 参数时间戳转换成的日期对象
		var Y = tmDate.getFullYear(),
		m = tmDate.getMonth() + 1,
		d = tmDate.getDate();
		var H = tmDate.getHours(),
		i = tmDate.getMinutes(),
		s = tmDate.getSeconds();
		return (Y + "-" + this.zeroize(m) + "-" + this.zeroize(d) + " " + this.zeroize(H) + ":" + this.zeroize(i) + ":" + this.zeroize(s));
	},
    /** 入会审批 */
	getList() {
	  this.loading = true;
	  getMyGuildInfo(this.queryParams).then(response => {
	    this.loading = false
		this.list = []
		this.list.push(response.data)
	  });
	},
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
		avatar:'',
		guildName:'',
		intro:'',
		userRecode:'',
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleCurrentChange(val) {
		this.queryParams.page = val;
		this.getList();
	},
	// 编辑资料
	handleUpdate(row) {
	  this.form = row;
	  this.open = true;
	  this.title = '编辑'
	},
	/** 提交按钮 */
	submitForm: function() {
	  this.$refs["form"].validate(valid => {
	    if (valid) {
	      updateGuildInfo(this.form).then(response => {
	        this.$message({ message: response.msg, type: 'success'});
	        this.open = false;
	        this.getList();
	      });
	    }
	  });
	},

  }
};
</script>
<style>
	.el-table td, .el-table th{
		padding: 6px 0px;
	}
	.el-table{
		font-size: 12px;
	}
	.el-button+.el-button{
		margin-left: 0px;
	}
	.el-table th.gutter{
        display: table-cell!important;
    }
</style>


// WEBPACK FOOTER //
// index.vue?128240ab